import type { ChatMessageSummaryBasicInfoAllOfTwoType } from './chatMessageSummaryBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type ChatMessageSummaryBasicInfoAllOfTwo = {
  content?: string;
  type?: ChatMessageSummaryBasicInfoAllOfTwoType;
};
